import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '@material/material.module';
import { JobLocationPipe } from '@shared/job-location/job-location.pipe';

import { JobLocationComponent } from './job-location.component';

@NgModule({
  declarations: [JobLocationComponent, JobLocationPipe],
  imports: [CommonModule, MaterialModule],
  exports: [JobLocationComponent, JobLocationPipe]
})
export class JobLocationModule {}
